import React, { Component, Fragment } from 'react';
import { BryntumFullscreenButton } from './BryntumFullscreenButton';
import { BryntumTrialButton } from './BryntumTrialButton';
export class BryntumDemoHeader extends Component {
    constructor() {
        super(...arguments);
        this.title = document.title.split(' - ')[1] || document.title;
    }
    render() {
        return (React.createElement(Fragment, null,
            React.createElement("header", { className: "demo-header" },
                React.createElement("div", { id: "title-container" },
                    React.createElement("a", { id: "title", href: this.props.href },
                        React.createElement("h1", null, this.title))),
                this.props.children,
                React.createElement(BryntumTrialButton, { productId: "schedulerpro", cls: "b-green b-raised" }),
                React.createElement(BryntumFullscreenButton, null))));
    }
}
//# sourceMappingURL=BryntumDemoHeader.js.map